export default "__VITE_ASSET__Krp0EvwZ__"